import { defaultHttpClient } from '../../httpClient';
import type { TypographyVariant } from '@banhala/ui-kit';

export interface AddCartRecommendItem {
  item: {
    sno: number;
    name: string;
    image: string;
    market_sno: number;
    market_name: string;
    market_type: string;
    delivery_type: 'standard' | 'today' | 'shak';
    sell_count: number;
    discount_rate: number;
    first_page_rendering: {
      goods_name: string;
      market_name: string;
      cover_image: string;
      market_image: string | null;
      discount_rate: number;
      original_price: number;
      price: number;
    };
    is_new: boolean;
    price: number;
    expected_reward: null;
    like: {
      goods_sno: number;
      is_liked: boolean;
      folder_sno: number | null;
      referrer: {
        list_id: string;
        list_index: number;
      };
    };
    ad: {
      parameters: string;
      goods_sno: number;
      campaign_id: string;
      list_id: string;
    } | null;
    on_return: null;
    category_name: string;
    feedback_type: null;
    remote_deeplink: null;
  };
  logging: {
    ably_only_log: {
      schema_name: string;
      list_id: string;
      list_index: number;
      pool: string;
      goods_sno: number;
    };
    analytics: {
      GOODS_SNO: string;
      GOODS_NAME: string;
      MARKET_TYPE: string;
      MARKET_SNO: string;
      MARKET_NAME: string;
      CATEGORY_SNO: string;
      CATEGORY_NAME: string;
      STANDARD_CATEGORY_SNO: string;
      STANDARD_CATEGORY_NAME: string;
      DISCOUNT_RATE: number;
      SALES_PRICE: number;
      SALES_PRICE_RANGE: string;
      IS_NEW: string;
      DELIVERY_TYPE: string;
      IS_AD: string;
      LIST_PARAMS: string | null;
      MARKET_TYPE_SNO: string;
      REVIEW_COUNT: number;
      REVIEW_COUNT_RANGE: string;
      REVIEW_RATING: number;
      LIKES_COUNT: number;
      LIKES_COUNT_RANGE: string;
      PROMOTION_TAG: string[];
      HAS_AWARD: boolean;
      IS_ONLY_ABLY: boolean;
      IMAGE_BADGE_LIST: string[];
      IS_BLACK_FRIDAY: boolean;
      LIST_ID: string;
      LIST_INDEX: number;
    };
  };
  render: {
    contents: ('PRICE' | 'NAME' | 'STORE' | 'CHIPS')[];
    size: 'SMALL';
    data: {
      image: {
        url: string;
        use_animation: boolean;
        ratio: 1 | 1.2;
      };
      name: string;
      price: string;
      has_ad_badge: boolean;
      name_lines: number;
      discount_rate: string;
      closed_reason: string | null;
      image_badge: string | null;
      image_badge_width: number | null;
      image_badge_height: number | null;
      image_badge_list: Array<{
        type: 'TODAY_DELIVERY' | 'ONLY_ABLY';
        image_url: string;
        image_width: number;
        image_height: number;
      }>;
      chips: {
        name: string;
        type: string;
        meta?: {
          bg_color: string;
          border_color: string;
          border_width: 1;
          rounded_corner_radius: number;
          text_color: string;
          text_style: TypographyVariant;
        };
      }[];
      store_text: string;
      nudging_text: string | null;
      ranking: number | null;
      actions: 'LIKE'[];
      discount_end_text: string | null;
      top_nudging_text: string | null;
      price_description: {
        text: string;
      } | null;
      today_delivery_order_deadline_time: string | null;
    };
  };
}

export interface AddCartRecommendCarousel {
  title: string;
  item_list: AddCartRecommendItem[];
}

export interface AddCartRecommendResponse {
  carousels: AddCartRecommendCarousel[];
}

export const getAddCartRecommend = (goods_sno: number) => {
  return defaultHttpClient
    .request<AddCartRecommendResponse>({
      method: 'GET',
      url: '/api/v2/carts/add_cart_recommend/',
      params: {
        goods_sno,
      },
    })
    .then(result => result.data);
};
